<div class="row">
  <div class="col-md-6">
    <app-form-group label="Id">
      <input disabled required class="form-control" [(ngModel)]="portOfCall['id']">
    </app-form-group>

    <app-form-group label="Sorting key">
      <input required type="number" [min]="0" [(ngModel)]="portOfCall.sortingKey">
    </app-form-group>

    <app-form-group label="Port">
      <app-search required [(ngModel)]="portOfCall.port" [searchFunction]="refData.findPort"
        [inputFormatter]="refData.portFormatter" placeholder="Find port">
      </app-search>
    </app-form-group>

    <app-form-group label="Port authority">
      <app-search required [(ngModel)]="portOfCall.portAuthority" [searchFunction]="refData.findOrganisations"
        [inputFormatter]="refData.portAuthorityFormatter" placeholder="Find port authority organisation">
      </app-search>
    </app-form-group>

    <app-form-group label="Customs office">
      <app-select required [(ngModel)]="portOfCall.customsOffice" [optionsProvider]="customsOffices"
        [addSelectedIfNotExists]="true" [formatter]="refData.customsOfficeFormatter"
        placeholder="– Select a customs office –">
      </app-select>
    </app-form-group>

    <app-form-group label="Authorise organisations">
      <app-yes-no required [(ngModel)]="portOfCall.authoriseOrganisationsDisabled" [formatter]="negativeLogicFormatter">
      </app-yes-no>
    </app-form-group>

    <app-form-group label="Actual time of arrival">
      <app-yes-no required [(ngModel)]="portOfCall.ataReported" [formatter]="reportingFormatter"></app-yes-no>
    </app-form-group>

    <app-form-group label="Actual time of departure">
      <app-yes-no required [(ngModel)]="portOfCall.atdReported" [formatter]="reportingFormatter"></app-yes-no>
    </app-form-group>

    <app-form-group label="Actual time of departure port">
      <app-yes-no required [(ngModel)]="portOfCall.atdPortReported" [formatter]="reportingFormatter"></app-yes-no>
    </app-form-group>
  </div>

  <div class="col-md-6">
    <app-form-group label="Waste">
      <app-yes-no required [(ngModel)]="portOfCall.wasteEnabled" [formatter]="positiveLogicFormatter"></app-yes-no>
    </app-form-group>

    <app-form-group label="Dangerous goods">
      <app-yes-no required [(ngModel)]="portOfCall.dangerousGoodsEnabled" [formatter]="positiveLogicFormatter">
      </app-yes-no>
    </app-form-group>

    <app-form-group label="Harbour dues">
      <app-yes-no required [(ngModel)]="portOfCall.harbourDuesEnabled" [formatter]="positiveLogicFormatter">
      </app-yes-no>
    </app-form-group>

    <app-form-group label="Order nautical services">
      <app-yes-no required [(ngModel)]="portOfCall.orderNauticalServicesEnabled" [formatter]="positiveLogicFormatter"
        (ngModelChange)="orderNauticalServicesChanged($event)">
      </app-yes-no>
    </app-form-group>

    <app-form-group label="Notifications to port authority">
      <app-yes-no required [(ngModel)]="portOfCall.enableNotificationsToPa" [formatter]="positiveLogicFormatter">
      </app-yes-no>
    </app-form-group>

    <app-form-group label="Port authority declaration">
      <app-yes-no required [(ngModel)]="portOfCall.paDeclarationRequired" [formatter]="requirementFormatter">
      </app-yes-no>
    </app-form-group>

    <app-form-group label="Single window declaration">
      <app-yes-no required [(ngModel)]="portOfCall.swDeclarationRequired" [formatter]="requirementFormatter">
      </app-yes-no>
    </app-form-group>

    <app-form-group label="Tug boats">
      <app-yes-no required [(ngModel)]="portOfCall.tugBoatsRequired" [formatter]="requirementFormatter"></app-yes-no>
    </app-form-group>

    <app-form-group label="Explicit clearance by Port Authority">
      <app-yes-no required [(ngModel)]="portOfCall.portAuthorityClearance" [formatter]="positiveLogicFormatter">
      </app-yes-no>
    </app-form-group>

    <app-form-group label="Visit order overdue warnings">
      <app-yes-no required [(ngModel)]="portOfCall.visitOrderOverdueWarningEnabled" [formatter]="positiveLogicFormatter">
      </app-yes-no>
    </app-form-group>
  </div>

  @if (portOfCall.orderNauticalServicesEnabled) {
    <div class="declaration-block">
      <h2>Order deadlines</h2>
    </div>
    <app-edit-order-deadlines header="Incoming at sea" [deadlines]="portOfCall.orderDeadlines.incomingAtSea"></app-edit-order-deadlines>
    <app-edit-order-deadlines header="Incoming at hinterland" [deadlines]="portOfCall.orderDeadlines.incomingAtHinterland"></app-edit-order-deadlines>
    <app-edit-order-deadlines header="Between berths" [deadlines]="portOfCall.orderDeadlines.betweenBerths"></app-edit-order-deadlines>
  }

  @if (context.isVlissingenOrTerneuzenVisit(portOfCall.port?.locationUnCode)) {
    <div class="declaration-block">
      <h2>Pilot transfer points</h2>
    </div>
    <div class="my-3">
      <i>Pilot transfer points can be used to mark a special traject on a visit. This refdata contains from which pilot station the pilot can transfer to</i>
    </div>
    @for (pilotTransferPoint of portOfCall.pilotTransferPoints; track pilotTransferPoint.pilotTransferPointId) {
      <app-collapse [collapse]="pilotTransferPointsTpl" [deleteHandle]="deletePilotTransferPoint(pilotTransferPoint)">
        <div class="row py-2 px-3">
          <div class="col-4">
            <i class="fas fa-map-marker-alt"></i>
            {{ pilotTransferPoint.name }}
          </div>
          <div class="col-8">
            <i class="fas fa-route"></i>
            {{ nextTransferPointsFormatted(pilotTransferPoint.nextTransferPoints) }}
          </div>
        </div>
      </app-collapse>
      <ng-template #pilotTransferPointsTpl>
        <div class="collapse">
          <div class="mx-3 pt-3">
            <app-edit-pilot-transfer-point [transferPoint]="pilotTransferPoint"></app-edit-pilot-transfer-point>
          </div>
        </div>
      </ng-template>
    }
    <div class="col-md-6 pt-3 pb-5">
      <button type="button" class="btn btn-info" (click)="addNewPilotTransferPoint()">Add new Pilot transfer point</button>
    </div>
  }
</div>
